import Drift from './Drift';
import texts from './data.js';

const DriftCanvas = () => {
  return (
    <div style={{ width: '100%', height: '100%', cursor: 'none' }}>

      {/* panel 1 — fine white mist, barely responds, mostly wanders */}
      <Drift
        particleCount={2000}
        particleColor='white'
        particleRadius={0.9}
        gravity={0.018}
        damping={99}
        wanderStrength={0.18}
        maxSpeed={1.2}
        fillColor='white'
        barColor='rgba(255,255,255,0.4)'
        documentBackgroundColor='#06071a'
        texts={texts[0]}
      />

      {/* panel 2 — large slow lavender blobs, heavy and organic */}
      <Drift
        particleCount={35}
        particleColor='white'
        particleRadius={90}
        gravity={0.11}
        damping={0.93}
        wanderStrength={2}
        maxSpeed={7}
        fillColor='#e0d4ff'
        barColor='rgba(192,168,255,0.55)'
        documentBackgroundColor='lightblue'
        texts={texts[1]}
      />

      {/* panel 3 — dense ember sparks, fast and chaotic */}
      <Drift
        particleCount={1060}
        particleColor='#ff7722'
        particleRadius={1.8}
        gravity={0.22}
        damping={0.47}
        wanderStrength={0.4}
        maxSpeed={1}
        fillColor='#ffeedd'
        barColor='rgba(255,160,80,0.6)'
        documentBackgroundColor='#0c0400'
        texts={texts[2]}
      />

    </div>
  );
};

export default DriftCanvas;
